import { ActionMap } from '@/store/store.interface';

import { HrefLangPayloadType, HrefLangType, HrefLangActions } from './hrefLang.interface';

export type HrefLangActionsType =
  ActionMap<HrefLangPayloadType>[keyof ActionMap<HrefLangPayloadType>];

export const HrefLangReducer = (state: HrefLangType[], action: HrefLangActionsType) => {
  switch (action.type) {
    case HrefLangActions.Add:
      return [...action.payload];
    default:
      return [...state];
  }
};
